import { Component, OnInit, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';

import { AppService } from './app.service';
import { AuthService } from './_core/auth.service';
import { EntityService } from './_core/entity.service';
import { ExpayService } from 'src/app/_services/expay.service';

import * as _ from 'lodash';
import {InAppService} from "./_core/inapp.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: {
        '[class.cordova]': 'cordova'
    },
    standalone: false
})
export class AppComponent implements OnInit {
    title:string = 'tabitPay';
	cordova: string = '';
    loading: boolean = true;
    @BlockUI() blockUI: NgBlockUI;

    constructor(
        public appService: AppService,
		private authService: AuthService,
		public entityService: EntityService,
		public inAppService: InAppService,
        public expayService: ExpayService,
		private router: Router,
        @Inject(PLATFORM_ID) private _platformId: Object
    ) {
        isPlatformBrowser(this._platformId);
    }

	ngOnInit() {
		if (this.appService.needReload) return;

		this.appService.blockUI = this.blockUI;
		this.onLoad(false);

		// alert(`in app (${document["inApp"]}), safe area: (${document["topSafeArea"]})`);

		document.ondblclick = e => {
			e.preventDefault();
		};

		if (window.screen && window.screen.orientation && 'lock' in window.screen.orientation) {
			// @ts-ignore
			window.screen.orientation.lock('portrait');
		}
    }

	onLoad(showSplash = false) {
		this.loading = true;
		this.blockUI.start();

		this.authService.restoreSignIn()
			.then(() => {
				const url = this.router.url;
				const params = this.appService.urlParams;
				if (url.includes('/orderin') || url.includes('/opentab')) {

				} else {
					if (!params.site) {
						this.router.navigate(['/info']);
						return;
					}
					this.router.navigate(['/pay/tabit-pay']);
				}
			}).catch(err => {
				if (err && err.staus == 403) this.authService.signOut()
			}).then(o => {
				this.blockUI.stop();
				this.loading = false;
			});
	}

}
